import React from "react"
import autobind from "class-autobind"
import { Dialog, TextField, FlatButton, FontIcon, IconButton } from "material-ui"
import { Table, TableBody, TableFooter, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import strings from "../../localization/strings"
import Clear from "../../components/misc/Clear"
import { IJobPhase } from "../../models"
import { checkPhaseFieldAvailable } from "../../helpers/punchHelper"
import AccountStore from "../../stores/AccountStore"
interface IProps {
	phases: IJobPhase[]
	handleClose(): void
	handleSave(phase: IJobPhase): void
}
interface IState {
	phases: IJobPhase[]
	selectedPhase: IJobPhase
	search: string
	total: number
	offset: number
}
const styles = {
	nameCol: {
		paddingLeft: 5,
		paddingRight: 5,
	},
	otherCol: {
		paddingLeft: 25,
		paddingRight: 25,
		width: 100
	}
}

export default class AddPhaseDialogForChip extends React.Component<IProps, IState> {
	private limit
	private searchField
	constructor(props) {
		super(props)
		this.state = {
			phases: [],
			selectedPhase: null,
			search: "",
			offset: 0,
			total: 0
		}
		autobind(this)
		const tempLimit = Math.floor(window.innerHeight / 50) - 9
		this.limit = tempLimit > 8 ? 8 : tempLimit
	}

	componentDidMount() {
		this.getPhases()
	}

	getPhases() {
		const searchedPhases = this.state.search.trim() ? this.props.phases.filter(item => item.Name.toLowerCase().includes(this.state.search.toLowerCase())) : this.props.phases
		this.setState({
			phases: searchedPhases.slice(this.state.offset, this.state.offset + this.limit),
			total: searchedPhases.length
		})
	}

	offsetChange(offset) {
		this.setState({
			offset,
			selectedPhase: null
		}, () =>
			this.getPhases()
		)
	}

	render() {
		return (
			<Dialog
				modal
				open
				title={ checkPhaseFieldAvailable("singular") ? `Choose ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel}` : strings.Choose_Phase}
				actions={[
					<FlatButton
						data-intercom-target={"Phase-Btn-ClosePhaseSelectionDialog"}
						label={strings.Cancel}
						secondary
						onClick={this.props.handleClose}
					/>,
					<FlatButton
						data-intercom-target={"Phase-Btn-SaveSelectedPhase"}
						label={strings.OK}
						primary
						keyboardFocused
						onClick={() => this.props.handleSave(this.state.selectedPhase)}
					/>
				]}
				onRequestClose={this.props.handleClose}
			>
				<div style={{ padding: 20, paddingLeft: 35 }}>
					<i style={{ fontSize: 25, cursor: "pointer" }} className="fa fa-search" onClick={() => this.searchField.focus()} />
					<TextField
						data-intercom-target={"Phase-Entry-Search"}
						hintText={strings.search}
						style={{ marginRight: 20, width: "90%", marginLeft: 15 }}
						value={this.state.search}
						onChange={e =>
							this.setState({
								search: e.target.value,
								offset: 0,
								selectedPhase: null
							}, () =>
								this.getPhases()
							)
						}
						ref={item => this.searchField = item}
					/>
					<Clear />
				</div>
				<div style={{ textAlign: "center", height: 500 }}>
					<Table
						onCellClick={rowNumber => this.setState({ selectedPhase: this.state.phases[rowNumber] })}
						multiSelectable={false}
					>
						<TableHeader>
							<TableRow>
								<TableHeaderColumn style={styles.nameCol}>{strings.Name}</TableHeaderColumn>
								<TableHeaderColumn style={styles.otherCol}>{strings.Cost_Code}</TableHeaderColumn>
							</TableRow>
						</TableHeader>
						<TableBody showRowHover deselectOnClickaway>
							{this.state.phases.map((item, index) =>
								<TableRow data-intercom-target={`Phase-SelectPhase${index+1}`} key={index} selected={this.state.selectedPhase === item}>
									<TableRowColumn style={styles.nameCol} title={item.Name}>{item.Name}</TableRowColumn>
									<TableRowColumn style={styles.otherCol} title={item.CostCode}>{item.CostCode}</TableRowColumn>
								</TableRow>
							)}
						</TableBody>
						<TableFooter>
							<TableRow className="TableFooter" style={{ borderBottom: 0 }}>
								<TableRowColumn style={{ float: "right" }}>
									<IconButton
										data-intercom-target={"Phase-ChoosePhase-Btn-OpenFirstPage"}
										disabled={this.state.offset === 0}
										onClick={() => this.offsetChange(0)}
									>
										<FontIcon className="fa fa-step-backward" />
									</IconButton>
									<IconButton
										data-intercom-target={"Phase-ChoosePhase-Btn-OpenPreviousPage"}
										disabled={this.state.offset === 0}
										onClick={() => this.offsetChange(this.state.offset - this.limit)}
									>
										<FontIcon className="fa fa-chevron-left" />
									</IconButton>
									<IconButton
										data-intercom-target={"Phase-ChoosePhase-Btn-OpenNextPage"}
										disabled={this.state.offset + this.limit >= this.state.total}
										onClick={() => this.offsetChange(this.state.offset + this.limit)}
									>
										<FontIcon className="fa fa-chevron-right" />
									</IconButton>
									<IconButton
										data-intercom-target={"Phase-ChoosePhase-Btn-OpenLastPage"}
										disabled={this.state.offset + this.limit >= this.state.total}
										onClick={() => this.state.total % this.limit === 0 ?
											this.offsetChange(this.state.total - this.limit) :
											this.offsetChange(this.state.total - (this.state.total % this.limit))
										}
									>
										<FontIcon className="fa fa-step-forward" />
									</IconButton>
								</TableRowColumn>
							</TableRow>
						</TableFooter>
					</Table>
				</div>
			</Dialog>
		)
	}
}
